/**
 * Escalation Banner Component
 * 
 * Displays warning banner when critical issues are detected in prewalk form data.
 * Shows escalations that will be filed with operations team.
 */

import { Banner } from '@ox/blox';
import type { EscalationPreview } from '@ox/visits-ui/types';

interface Props {
  escalations: EscalationPreview[];
  onDismiss?: () => void;
}

export function EscalationBanner({ escalations, onDismiss }: Props) {
  if (escalations.length === 0) {
    return null;
  }

  return (
    <Banner theme="warning" icon="error" onDismiss={onDismiss} className="escalation-banner">
      <div className="escalation-content">
        <strong className="escalation-title">⚠️ Critical Issues Detected</strong>
        <ul className="escalation-list">
          {escalations.map((escalation) => (
            <li key={escalation.reason} className="escalation-item">
              {escalation.message}
            </li>
          ))}
        </ul>
        <p className="escalation-footer">
          Our operations team will be notified immediately to resolve
          these before listing.
        </p>
      </div>
    </Banner>
  );
}
